/**
 * "Alex Reyes" → "AR". The first letter of the first two words, upper-cased.
 *
 * Drawn on the account button and on the Overview pane's avatar, and each had its own copy.
 * The server derives the same thing for board payloads (repos/board.js), so this is also the
 * one place to look if the two ever disagree.
 */
/**
 * "Arian Askarzadeh" → "Arian". What the account button in the nav says.
 *
 * The full name and the email are a line apart in the menu it opens, so the button does not
 * need to carry either: it is answering "am I signed in, and as me?", which a first name
 * settles. It also stops the one control in the bar whose width is set by a person's name
 * from being the widest thing in it. A single-word name is left alone.
 */
export const firstNameOf = (name) => String(name || '').trim().split(/\s+/)[0] || ''

export const initialsOf = (name) =>
  String(name || '')
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((w) => w[0].toUpperCase())
    .join('')

/**
 * 1536 → "1.5 KB", 2 097 152 → "2.1 MB". Decimal units, one decimal place, because this
 * sits in a table where "how big is a backup" is a glance, not a calculation.
 */
export function formatBytes(n) {
  const size = Number(n) || 0
  if (size < 1000) return `${size} B`
  const units = ['KB', 'MB', 'GB']
  let v = size / 1000
  let i = 0
  while (v >= 1000 && i < units.length - 1) {
    v /= 1000
    i++
  }
  return `${v.toFixed(1)} ${units[i]}`
}
